import { action, computed, observable } from 'mobx';
import { setter } from 'mobx-decorators';
import get from 'lodash/get';
import constants from 'Constants';
import * as comUtils from 'utils/Common';


export class FormOption {
  @setter @observable value;
  @setter @observable name;
  @setter @observable desc;

  constructor() {
    this.reset();
  }

  @action reset() {
    this.value = '';
    this.name = '';
    this.desc = '';
  }

  @action deserialize(data) {
    this.value = data.value;
    this.name = data.name;
    this.desc = data.desc;
  }
}


// Used for resetting `Store`
export function setFieldValues(self, defaults) {
  for (var fieldName in defaults) {
    let defaultValue = defaults[fieldName];
    self[fieldName] = defaultValue;
  }
};


// Ensure no duplicate fields for mappers
export function concatDeserializeMappers(firstMappers, secondMappers) {
    let fields = secondMappers.map((mapper) => mapper.field);
    firstMappers = firstMappers.filter((mapper) => !fields.includes(mapper.field));
    return [].concat(firstMappers, secondMappers);
};



// Mapper must have "cls" field returning object's class
export function deserializeObject(mapper, value) {
  const instance = new mapper.cls();
  if (value) instance.deserialize(value);
  return instance;
};


// Mapper must have "cls" field returning object's class. Value must be an array.
export function deserializeArrayObjects(mapper, data, accessor, value) {
    if (!Array.isArray(value)) {
      throw new Error(`Expecting array object for accessor (${accessor}) with ${JSON.stringify(value)}`);
    };

    const instanceList = [];
    value.forEach(function(rowData){
      const instance = new mapper.cls();
      instance.deserialize(rowData);
      instanceList.push(instance);
    });

    return instanceList;
};


export function deserializeMap(mapper, value) {
  const map = observable.map({});
  comUtils.loopObject(value, (mapKey, mapValue) => {
    map.set(mapKey, mapValue);
  })

  return map;
};


export function deserializeDate(mapper, data, accessor, dateValue) {
    return dateValue ? new Date(dateValue) : null;
};


export function deserializeTimestamp(mapper, data, accessor, timestampValue) {
    return timestampValue ? new Date(timestampValue*1000) : null;
};


export function deserializeWithMappers(self, mappers, data) {
  for (var mapper of mappers) {

    // By default, use `field` as accessor
    let accessor = 'accessor' in mapper ? mapper.accessor : mapper.field;

    // If can't find value from data with accessor, skip.
    let value = get(data, accessor, null);
    if (value === null) continue;

    // What it actually does:
    // this.id = data.id;
    if (!('type' in mapper)) {
      self[mapper.field] = value;
    }

    if (mapper.type === constants.DESERIALIZE_TYPE_MAP) {
      self[mapper.field] = deserializeMap(mapper, value);
    };

    // What it actually does:
    // let account = new AccountStore();
    // if (data.account) account.deserialize(data.account);
    if (mapper.type === constants.DESERIALIZE_TYPE_OBJECT) {
      self[mapper.field] = deserializeObject(mapper, value);
    };

    // What it actually does:
    // let accounts = [];
    // data.accounts.forEach(function(rowData){
    //   let account = new AccountStore();
    //   account.deserialize(rowData);
    //   accounts.push(account);
    // });
    if (mapper.type === constants.DESERIALIZE_TYPE_ARRAY_OBJECTS) {
      self[mapper.field] = deserializeArrayObjects(mapper, data, accessor, value);
    };

    // Custom extract function to retrieve deserialized value
    if (mapper.type === constants.DESERIALIZE_TYPE_CUSTOM) {
      self[mapper.field] = mapper.extract(mapper, data, accessor, value);
    };
  }
};




